import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function Paper({
  color = 'icon.primary',
  stroke = '1',
  fill = 'none',
  isChecked = false,
  ...props
}) {
  return (
    <IconBase viewBox='0 0 13 14' {...props}>
      <Path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M10.7755 3.41436L8.96001 1.59885C8.71928 1.35805 8.39276 1.22266 8.05226
         1.22266H3.44801C2.73891 1.22266 2.16406 1.7975 2.16406 2.50661V11.4943C2.16406
          12.2034 2.73891 12.7782 3.44801 12.7782H9.86777C10.5769 12.7782 11.1517 12.2034
           11.1517 11.4943V4.32211C11.1517 3.98162 11.0163 3.65509 10.7755 3.41436Z'
        stroke={color}
        strokeWidth={stroke}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
      {isChecked && (
        <Path
          d='M8.34701 6.27734L6.28931 8.33504L5.05469 7.10042'
          stroke={color}
          strokeWidth={stroke}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      )}
    </IconBase>
  )
}

Paper.propTypes = {
  color: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  stroke: PropTypes.string,
  isChecked: PropTypes.bool,
  fill: PropTypes.string,
}

export default Paper
